import { Utils } from 'choerodon-ui/dataset';
const { getNearStepValues, getPrecision, MAX_SAFE_INTEGER, MIN_SAFE_INTEGER, plus, parseNumber, bigNumberToFixed, parseBigNumber } = Utils;
export { MAX_SAFE_INTEGER, MIN_SAFE_INTEGER, getNearStepValues, getPrecision, plus, parseNumber, bigNumberToFixed, parseBigNumber, };
